import { RenderColumnInArea, RenderColumnInAreaType } from "../core/services/types";

export const defaultChartSettingsDropdownOptions = ["HOUR_OF_DAY", "DAY_OF_MONTH", "DATE", "DAY_OF_WEEK", "MONTH"];

export const reportTestsMoneyRegex = /\d+.\d{2} PLN/i;

export const groupGroupReportRenderArea: RenderColumnInArea = {
	rowType: RenderColumnInAreaType.GROUP,
	columnType: RenderColumnInAreaType.GROUP,
};
export const groupSummaryReportRenderArea: RenderColumnInArea = {
	rowType: RenderColumnInAreaType.GROUP,
	columnType: RenderColumnInAreaType.SUMMARY,
};

export const summarySummaryReportRenderArea: RenderColumnInArea = {
	rowType: RenderColumnInAreaType.SUMMARY,
	columnType: RenderColumnInAreaType.SUMMARY,
};
export const summaryGroupReportRenderArea: RenderColumnInArea = {
	rowType: RenderColumnInAreaType.SUMMARY,
	columnType: RenderColumnInAreaType.GROUP,
};
